module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.22147/js/img/valuePropsSection/247Support.png"